import imageCompression from 'browser-image-compression';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { emphasize, styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useContext, useEffect, useRef, useState } from "react";
import Rating from "@mui/material/Rating";
import { FaCloudUploadAlt } from "react-icons/fa";
import Button from "@mui/material/Button";
import {
  deleteData,
  deleteImages,
  editData,
  fetchDataFromApi,
  postData,
  uploadImage,
} from "../../utils/api";
import { MyContext } from "../../App";
import CircularProgress from "@mui/material/CircularProgress";
import { FaRegImages } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import axios from "axios";
import CountryDropdown from "../../components/CountryDropdown";
import Select2 from "react-select";
import {
  FormControlLabel,
  Switch,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  InputAdornment,
  TextField,
  Chip as MuiChip,
  Badge,
  Alert,
  Tabs,
  Tab,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Checkbox,
  ListItemSecondaryAction
} from "@mui/material";
import { MdAdd, MdDelete, MdEdit, MdImage, MdInventory, MdAttachMoney, MdInfo, MdWarning, MdCheck, MdError } from "react-icons/md";
import { FiPackage, FiEdit3, FiCamera } from "react-icons/fi";
import { BiImageAdd, BiMoney } from "react-icons/bi";
import { AiOutlineStock, AiOutlineLink, AiOutlineUnorderedList } from "react-icons/ai";

//breadcrumb code
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey;
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const EditUpload = () => {
  const [categoryVal, setcategoryVal] = useState("");
  const [subCatVal, setSubCatVal] = useState("");

  const [productRams, setProductRAMS] = useState([]);
  const [productWeight, setProductWeight] = useState([]);
  const [productSize, setProductSize] = useState([]);

  const [productRAMSData, setProductRAMSData] = useState([]);
  const [productWEIGHTData, setProductWEIGHTData] = useState([]);
  const [productSIZEData, setProductSIZEData] = useState([]);

  const [ratingsValue, setRatingValue] = useState(1);
  const [isFeaturedValue, setisFeaturedValue] = useState("");

  const [catData, setCatData] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [product, setProducts] = useState([]);
  const [isImageRemove, setIsImageRemove] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [countryList, setCountryList] = useState([]);

  // Enhanced Variant states with option-level data and proper stock handling
  const [hasVariants, setHasVariants] = useState(false);
  const [variantOptions, setVariantOptions] = useState([
    {
      name: "",
      values: [
        {
          value: "",
          images: [],
          price: "",
          oldPrice: "",
          stock: "0",
          sku: "",
          isActive: true
        }
      ]
    }
  ]);
  const [variants, setVariants] = useState([]);
  const [variantImages, setVariantImages] = useState({});
  const [uploadingVariantImages, setUploadingVariantImages] = useState({});
  const [uploadingOptionImages, setUploadingOptionImages] = useState({});
  const [editingVariant, setEditingVariant] = useState(null);
  const [showVariantForm, setShowVariantForm] = useState(false);
  const [showVariantDetailDialog, setShowVariantDetailDialog] = useState(false);
  const [selectedVariantForDetail, setSelectedVariantForDetail] = useState(null);
  const [showImageUploadDialog, setShowImageUploadDialog] = useState(false);
  const [selectedVariantForImages, setSelectedVariantForImages] = useState(null);
  const [dialogTabValue, setDialogTabValue] = useState(0);

  // ========== ALTERNATIVE PRODUCTS STATES ==========
  const [alternativeProducts, setAlternativeProducts] = useState([]);
  const [openAlternativeDialog, setOpenAlternativeDialog] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [searchAlternative, setSearchAlternative] = useState("");
  const [loadingAlternatives, setLoadingAlternatives] = useState(false);
  // =================================================

  let { id } = useParams();

  const history = useNavigate();

  const [formFields, setFormFields] = useState({
    name: "",
    subCat: "",
    subCatName: "",
    description: "",
    brand: "",
    price: null,
    oldPrice: null,
    catName: "",
    catId: "",
    subCatId: "",
    category: "",
    countInStock: null,
    rating: 0,
    isFeatured: null,
    discount: 0,
    productRam: [],
    size: [],
    productWeight: [],
    location: [],
    additionalInfo: [],
    specification: [],
    hasVariants: false,
    variantOptions: [],
    variants: [],
  });

  // ENHANCED: Stock value sanitization function
  const sanitizeStockValue = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === '' ||
      (typeof value === 'string' && value.trim() === '')) {
      return defaultValue;
    }

    let stringValue = String(value).trim();
    let numValue = Number(stringValue);

    if (isNaN(numValue) || !isFinite(numValue)) {
      return defaultValue;
    }

    if (numValue < 0) {
      return 0;
    }

    return Math.floor(numValue);
  };

  // ENHANCED: Automatic discount calculation
  const calculateDiscount = (price, oldPrice) => {
    if (!price || !oldPrice || parseFloat(oldPrice) <= parseFloat(price)) {
      return 0;
    }
    const discount = ((parseFloat(oldPrice) - parseFloat(price)) / parseFloat(oldPrice)) * 100;
    return Math.round(discount * 100) / 100; // Round to 2 decimal places
  };

  // ENHANCED: Auto-fill variant data based on product name and option values
  const autoFillVariantData = (combination, productName) => {
    const sku = `${productName ? productName.replace(/\s+/g, '-').toLowerCase() : 'product'}-${combination.map(c => c.value).join('-').toLowerCase()}`;
    return {
      sku,
      weight: '',
      dimensions: {
        length: 0,
        width: 0,
        height: 0
      },
      minOrderQuantity: 1,
      maxOrderQuantity: 999,
      stockAlert: 10,
      barcode: '',
      notes: ''
    };
  };

  // ENHANCED: Get stock status with proper color coding
  const getStockStatusDisplay = (stock, stockAlert = 10) => {
    const stockValue = sanitizeStockValue(stock);

    if (stockValue === 0) {
      return {
        icon: <MdError />,
        color: '#c62828',
        bgColor: '#ffebee',
        borderColor: '#ffcdd2',
        text: 'Out of Stock',
        status: 'out_of_stock'
      };
    } else if (stockValue <= stockAlert) {
      return {
        icon: <MdWarning />,
        color: '#f57c00',
        bgColor: '#fff8e1',
        borderColor: '#ffcc02',
        text: `Low Stock (${stockValue} left)`,
        status: 'low_stock'
      };
    } else {
      return {
        icon: <MdCheck />,
        color: '#2e7d32',
        bgColor: '#e8f5e8',
        borderColor: '#c8e6c9',
        text: `In Stock (${stockValue} available)`,
        status: 'in_stock'
      };
    }
  };

  const handleAdditionalInfoChange = (index, field, value) => {
    const newInfo = [...formFields.additionalInfo];
    newInfo[index][field] = value;
    setFormFields({
      ...formFields,
      additionalInfo: newInfo
    });
  };

  const handlespecificationChange = (index, field, value) => {
    const newInfo = [...formFields.specification];
    newInfo[index][field] = value;
    setFormFields({
      ...formFields,
      specification: newInfo
    });
  };

  const removespecification = (index) => {
    const newInfo = [...formFields.specification];
    newInfo.splice(index, 1);
    setFormFields({
      ...formFields,
      specification: newInfo
    });
  };

  const removeAdditionalInfo = (index) => {
    const newInfo = [...formFields.additionalInfo];
    newInfo.splice(index, 1);
    setFormFields({
      ...formFields,
      additionalInfo: newInfo
    });
  };

  const productImages = useRef();
  const context = useContext(MyContext);
  const formdata = new FormData();

  useEffect(() => {
    const newData = {
      value: "All",
      label: "All",
    };
    const updatedArray = [...context?.countryList];
    updatedArray.unshift(newData);
    setCountryList(updatedArray);
  }, [context?.countryList]);


  // useEffect(() => {
  //   const subCatArr = [];

  //   context.catData?.categoryList?.length !== 0 &&
  //     context.catData?.categoryList?.map((cat, index) => {
  //       if (cat?.children.length !== 0) {
  //         cat?.children?.map((subCat) => {
  //           subCatArr.push(subCat);
  //         });
  //       }
  //     });

  //   setSubCatData(subCatArr);
  // }, [context.catData]);


  useEffect(() => {
  if (formFields.catId && context.catData?.categoryList) {
    const selectedCategory = context.catData.categoryList.find(
      (cat) => cat._id === formFields.catId
    );

    if (selectedCategory?.children) {
      setSubCatData(selectedCategory.children);
    }
  }
}, [formFields.catId, context.catData]);


  useEffect(() => {
    window.scrollTo(0, 0);
    context.setselectedCountry("");
    setCatData(context.catData);

    fetchDataFromApi(`/api/products/${id}`).then((res) => {
      console.log('Loaded product data:', res);
      setProducts(res);

      // ENHANCED: Set form fields including variant data with proper stock handling and auto discount calculation
      const autoCalculatedDiscount = calculateDiscount(res.price, res.oldPrice);

      setFormFields({
        name: res.name,
        description: res.description,
        brand: res.brand,
        price: res.price,
        oldPrice: res.oldPrice,
        catName: res.catName,
        category: res.category,
        catId: res.catId,
        subCat: res.subCat,
        countInStock: sanitizeStockValue(res.countInStock),
        rating: res.rating,
        isFeatured: res.isFeatured,
        discount: res.discount || autoCalculatedDiscount, // Use existing or calculate
        productRam: Array.isArray(res.productRam) ? res.productRam : [],
        size: Array.isArray(res.size) ? res.size : [],
        productWeight: Array.isArray(res.productWeight) ? res.productWeight : [],
        location: Array.isArray(res.location) ? res.location : [],
        additionalInfo: res.additionalInfo || [],
        specification: res.specification || [],
        hasVariants: res.hasVariants || false,
        variantOptions: res.variantOptions || [],
        variants: res.variants || []
      });

      // ENHANCED: Set variant states if product has variants with proper stock initialization and auto-fill
      if (res.hasVariants) {
        setHasVariants(true);
        const initializedVariantOptions = res.variantOptions?.length > 0
          ? res.variantOptions.map(option => ({
            ...option,
            values: option.values.map(value => ({
              ...value,
              price: value.price || "",
              oldPrice: value.oldPrice || "",
              stock: sanitizeStockValue(value.stock, 0).toString(),
              // Auto-calculate discount for option values
              discount: calculateDiscount(value.price, value.oldPrice)
            }))
          }))
          : [
            {
              name: "",
              values: [
                {
                  value: "",
                  images: [],
                  price: "",
                  oldPrice: "",
                  stock: "0",
                  sku: "",
                  isActive: true
                }
              ]
            }
          ];

        setVariantOptions(initializedVariantOptions);

        // ENHANCED: Initialize variants with sanitized stock values and auto-fill data
        const initializedVariants = res.variants?.map(variant => ({
          ...variant,
          countInStock: sanitizeStockValue(variant.countInStock, 0),
          // Auto-calculate discount for variants
          discount: variant.discount || calculateDiscount(variant.price, variant.oldPrice),
          // Auto-fill missing data
          ...autoFillVariantData(variant.combination, res.name)
        })) || [];

        setVariants(initializedVariants);
      }

      // ========== LOAD ALTERNATIVE PRODUCTS ==========
      if (res.alternativeProducts && Array.isArray(res.alternativeProducts)) {
        // Fetch full product details for each alternative
        const loadAlternatives = async () => {
          const alternativeProductsData = [];
          for (const alt of res.alternativeProducts) {
            try {
              const productData = await fetchDataFromApi(`/api/products/${alt.productId}`);
              if (productData) {
                alternativeProductsData.push({
                  ...productData,
                  displayOrder: alt.displayOrder
                });
              }
            } catch (error) {
              console.error('Error loading alternative product:', error);
            }
          }
          // Sort by display order
          alternativeProductsData.sort((a, b) => a.displayOrder - b.displayOrder);
          setAlternativeProducts(alternativeProductsData);
        };
        loadAlternatives();
      }
      // ==============================================

      setSelectedLocation(res.location);
      setRatingValue(res.rating);
      setcategoryVal(res.category?._id);
      setSubCatVal(res.subCatId);
      setisFeaturedValue(res.isFeatured);
      setProductRAMS(Array.isArray(res.productRam) ? res.productRam : []);
      setProductSize(Array.isArray(res.size) ? res.size : []);
      setProductWeight(Array.isArray(res.productWeight) ? res.productWeight : []);

      // FIXED: Set existing images without auto-deletion
      setPreviews(res.images || []);
      context.setProgress(100);
    });

    fetchDataFromApi("/api/productWeight").then((res) => {
      setProductWEIGHTData(res);
    });
    fetchDataFromApi("/api/productRAMS").then((res) => {
      setProductRAMSData(res);
    });
    fetchDataFromApi("/api/productSIZE").then((res) => {
      setProductSIZEData(res);
    });
  }, []);

  // ========== ALTERNATIVE PRODUCTS FUNCTIONS ==========

  // Load available products for alternatives
  const loadAvailableProducts = async () => {
    try {
      setLoadingAlternatives(true);
      const response = await fetchDataFromApi('/api/products');

      if (response && response.products) {
        // Filter out the current product and products already selected as alternatives
        const filteredProducts = response.products.filter(
          product => product._id !== id && !alternativeProducts.some(alt => alt._id === product._id)
        );
        setAvailableProducts(filteredProducts);
      }
    } catch (error) {
      console.error('Error loading products:', error);
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to load products",
      });
    } finally {
      setLoadingAlternatives(false);
    }
  };

  // Open alternative products dialog
  const handleOpenAlternativeDialog = () => {
    loadAvailableProducts();
    setOpenAlternativeDialog(true);
  };

  // Close alternative products dialog
  const handleCloseAlternativeDialog = () => {
    setOpenAlternativeDialog(false);
    setSearchAlternative("");
  };

  // Add alternative product
  const handleAddAlternative = (product) => {
    if (alternativeProducts.some(p => p._id === product._id)) {
      // Already added, remove it
      const newAlternatives = alternativeProducts.filter(p => p._id !== product._id);
      setAlternativeProducts(newAlternatives);
      setAvailableProducts(prev => [...prev, product]);
      return;
    }

    const newAlternatives = [...alternativeProducts, product];
    setAlternativeProducts(newAlternatives);

    // Remove from available products
    setAvailableProducts(prev => prev.filter(p => p._id !== product._id));

    context.setAlertBox({
      open: true,
      error: false,
      msg: "Alternative product added successfully!",
    });
  };

  // Remove alternative product
  const handleRemoveAlternative = (productId) => {
    const removedProduct = alternativeProducts.find(p => p._id === productId);
    const newAlternatives = alternativeProducts.filter(p => p._id !== productId);
    setAlternativeProducts(newAlternatives);

    // Add back to available products if dialog is open
    if (removedProduct) {
      setAvailableProducts(prev => [...prev, removedProduct]);
    }

    context.setAlertBox({
      open: true,
      error: false,
      msg: "Alternative product removed",
    });
  };

  // Filter available products by search
  const filteredAvailableProducts = availableProducts.filter(product =>
    product.name.toLowerCase().includes(searchAlternative.toLowerCase()) ||
    product.brand?.toLowerCase().includes(searchAlternative.toLowerCase())
  );

  // =======================================================================

  // ALL YOUR EXISTING VARIANT FUNCTIONS HERE (I'm keeping them all - not changing anything)
  // Enhanced Variant functions with option-level data and proper stock handling
  const handleVariantToggle = (event) => {
    const isEnabled = event.target.checked;
    setHasVariants(isEnabled);
    setFormFields(prev => ({ ...prev, hasVariants: isEnabled }));

    if (!isEnabled) {
      setVariantOptions([
        {
          name: "",
          values: [
            {
              value: "",
              images: [],
              price: "",
              oldPrice: "",
              stock: "0",
              sku: "",
              isActive: true
            }
          ]
        }
      ]);
      setVariants([]);
      setVariantImages({});
    }
  };

  const addVariantOption = () => {
    setVariantOptions(prev => [
      ...prev,
      {
        name: "",
        values: [
          {
            value: "",
            images: [],
            price: "",
            oldPrice: "",
            stock: "0",
            sku: "",
            isActive: true
          }
        ]
      }
    ]);
  };

  const removeVariantOption = (index) => {
    const newOptions = variantOptions.filter((_, i) => i !== index);
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  const updateVariantOptionName = (index, name) => {
    const newOptions = [...variantOptions];
    newOptions[index].name = name;
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  // ENHANCED: Update variant option value with auto-discount calculation and auto-fill
  const updateVariantOptionValue = (optionIndex, valueIndex, field, value) => {
    const newOptions = [...variantOptions];

    if (field === 'stock') {
      const sanitizedStock = sanitizeStockValue(value, 0);
      newOptions[optionIndex].values[valueIndex][field] = sanitizedStock.toString();
    } else if (field === 'value') {
      newOptions[optionIndex].values[valueIndex].value = value;
      // Auto-fill SKU when value changes
      if (value.trim()) {
        const autoSku = `${formFields.name ? formFields.name.replace(/\s+/g, '-').toLowerCase() : 'product'}-${value.toLowerCase().replace(/\s+/g, '-')}`;
        newOptions[optionIndex].values[valueIndex].sku = autoSku;
      }
    } else if (field === 'price' || field === 'oldPrice') {
      newOptions[optionIndex].values[valueIndex][field] = value === "" ? "" : value;

      // Auto-calculate discount when price or oldPrice changes
      const currentValue = newOptions[optionIndex].values[valueIndex];
      if (field === 'price' && currentValue.oldPrice) {
        currentValue.discount = calculateDiscount(value, currentValue.oldPrice);
      } else if (field === 'oldPrice' && currentValue.price) {
        currentValue.discount = calculateDiscount(currentValue.price, value);
      }
    } else {
      newOptions[optionIndex].values[valueIndex][field] = value;
    }

    setVariantOptions(newOptions);

    if (field === 'value') {
      generateVariants(newOptions);
    }
  };

  const addVariantOptionValue = (optionIndex) => {
    const newOptions = [...variantOptions];
    newOptions[optionIndex].values.push({
      value: "",
      images: [],
      price: "",
      oldPrice: "",
      stock: "0",
      sku: "",
      isActive: true
    });
    setVariantOptions(newOptions);
  };

  const removeVariantOptionValue = (optionIndex, valueIndex) => {
    const newOptions = [...variantOptions];
    newOptions[optionIndex].values = newOptions[optionIndex].values.filter((_, i) => i !== valueIndex);
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  // FIXED: Completely rewritten variant option image upload function
  const onChangeOptionValueFile = async (e, optionIndex, valueIndex) => {
    try {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      // Create unique loading key
      const loadingKey = `${optionIndex}-${valueIndex}`;
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: true }));

      const compressionOptions = {
        maxSizeMB: 0.05,
        useWebWorker: true,
        alwaysKeepResolution: true,
        initialQuality: 0.3,
      };

      // Process all files and collect URLs directly
      const newImageUrls = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file || !(
          file.type === "image/jpeg" ||
          file.type === "image/jpg" ||
          file.type === "image/png" ||
          file.type === "image/webp"
        )) {
          context.setAlertBox({
            open: true,
            error: true,
            msg: "Please select valid image files (JPG, PNG, WEBP).",
          });
          continue;
        }

        try {
          // Compress image
          const compressedFile = await imageCompression(file, compressionOptions);

          // Create individual FormData for each image
          const singleImageFormData = new FormData();
          const renamedFile = new File(
            [compressedFile],
            `variant_${optionIndex}_${valueIndex}_${i}_${Date.now()}.${file.type.split('/')[1]}`,
            { type: compressedFile.type }
          );
          singleImageFormData.append('images', renamedFile);

          // Upload single image
          const uploadResponse = await uploadImage(`/api/products/upload`, singleImageFormData);

          if (uploadResponse && uploadResponse.success) {
            // Get the uploaded image URL directly from response
            const imageUploadResponse = await fetchDataFromApi(`/api/imageUpload`);

            if (imageUploadResponse && imageUploadResponse.length > 0) {
              const latestUpload = imageUploadResponse[imageUploadResponse.length - 1];
              const uploadedImages = latestUpload?.images || [];

              // Add only new URLs
              uploadedImages.forEach(imgUrl => {
                if (!newImageUrls.includes(imgUrl)) {
                  newImageUrls.push(imgUrl);
                }
              });

              // Clean up immediately after getting URLs
              await deleteData("/api/imageUpload/deleteAllImages");
            }
          }
        } catch (compressionError) {
          console.error('Image processing error:', compressionError);
          context.setAlertBox({
            open: true,
            error: true,
            msg: `Failed to process image ${i + 1}`,
          });
        }
      }

      // Update variant options with new images ONLY ONCE
      if (newImageUrls.length > 0) {
        const updatedOptions = [...variantOptions];

        // Ensure images array exists
        if (!updatedOptions[optionIndex].values[valueIndex].images) {
          updatedOptions[optionIndex].values[valueIndex].images = [];
        }

        // Add new images without duplicates
        newImageUrls.forEach(imgUrl => {
          if (!updatedOptions[optionIndex].values[valueIndex].images.includes(imgUrl)) {
            updatedOptions[optionIndex].values[valueIndex].images.push(imgUrl);
          }
        });

        setVariantOptions(updatedOptions);
        generateVariants(updatedOptions);

        context.setAlertBox({
          open: true,
          error: false,
          msg: `${newImageUrls.length} variant images uploaded successfully!`,
        });
      }

      // Clear loading state
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: false }));

    } catch (error) {
      console.error('Variant image upload error:', error);
      const loadingKey = `${optionIndex}-${valueIndex}`;
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: false }));

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to upload variant images. Please try again.",
      });
    }
  };

  // ENHANCED: Remove option value image using dedicated API endpoint
  const removeOptionValueImage = async (optionIndex, valueIndex, imageIndex, imgUrl, imgId) => {
    try {
      console.log('Deleting variant option image:', { optionIndex, valueIndex, imageIndex, imgUrl });

      // Optimistically remove from local state
      const newOptions = [...variantOptions];
      newOptions[optionIndex].values[valueIndex].images.splice(imageIndex, 1);
      setVariantOptions(newOptions);
      generateVariants(newOptions);

      // Delete from Cloudinary
      const deleteResponse = await deleteImages(`/api/products/deleteImage?img=${encodeURIComponent(imgUrl)}`);
      console.log('Variant image delete response:', deleteResponse);

      context.setAlertBox({
        open: true,
        error: false,
        msg: "Variant image deleted successfully!"
      });
    } catch (error) {
      console.error('Error deleting variant option image:', error);

      // Restore image in case of error
      const restoredOptions = [...variantOptions];
      restoredOptions[optionIndex].values[valueIndex].images.splice(imageIndex, 0, imgUrl);
      setVariantOptions(restoredOptions);
      generateVariants(restoredOptions);

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to delete variant image. Please try again."
      });
    }
  };

  // ENHANCED: Generate variants with auto-fill and auto-discount calculation
  const generateVariants = (options) => {
    const validOptions = options.filter(option =>
      option.name.trim() && option.values.some(val => val.value.trim())
    );

    if (validOptions.length === 0) {
      setVariants([]);
      return;
    }

    const combinations = [];

    const generateCombinations = (currentCombination, optionIndex) => {
      if (optionIndex >= validOptions.length) {
        combinations.push([...currentCombination]);
        return;
      }

      const currentOption = validOptions[optionIndex];
      const validValues = currentOption.values.filter(val => val.value.trim());

      for (const valueObj of validValues) {
        generateCombinations([...currentCombination, {
          option: currentOption.name,
          value: valueObj.value.trim(),
          optionData: valueObj
        }], optionIndex + 1);
      }
    };

    generateCombinations([], 0);

    const newVariants = combinations.map((combination, index) => {
      const existingVariant = variants.find(variant =>
        JSON.stringify(variant.combination.map(c => ({ option: c.option, value: c.value }))) ===
        JSON.stringify(combination.map(c => ({ option: c.option, value: c.value })))
      );

      const combinedPrice = combination.reduce((sum, c) => {
        const price = parseFloat(c.optionData.price) || 0;
        return sum + price;
      }, 0) || parseFloat(formFields.price) || 0;

      const combinedOldPrice = combination.reduce((sum, c) => {
        const oldPrice = parseFloat(c.optionData.oldPrice) || 0;
        return sum + oldPrice;
      }, 0) || parseFloat(formFields.oldPrice) || 0;

      const combinedStock = combination.reduce((sum, c) => {
        const stock = sanitizeStockValue(c.optionData.stock, 0);
        return sum + stock;
      }, 0);

      // FIXED: Keep variant images separate from option value images
      const combinedImages = combination.reduce((images, c) => {
        if (c.optionData.images && Array.isArray(c.optionData.images)) {
          const imageUrls = c.optionData.images.map(img => typeof img === 'object' ? img.img : img);
          return [...images, ...imageUrls];
        }
        return images;
      }, []);

      // Auto-calculate discount
      const autoDiscount = calculateDiscount(combinedPrice, combinedOldPrice);

      // Auto-fill variant data
      const autoFillData = autoFillVariantData(combination, formFields.name);

      return existingVariant ? {
        ...existingVariant,
        price: combinedPrice,
        oldPrice: combinedOldPrice,
        countInStock: combinedStock,
        discount: autoDiscount,
        // Keep existing variant-specific images separate
        images: existingVariant.images || []
      } : {
        id: `variant_${Date.now()}_${index}`,
        combination,
        sku: autoFillData.sku,
        price: combinedPrice,
        oldPrice: combinedOldPrice,
        countInStock: combinedStock,
        discount: autoDiscount,
        images: [], // Start with empty array for variant-specific images
        isActive: true,
        weight: autoFillData.weight,
        dimensions: autoFillData.dimensions,
        minOrderQuantity: autoFillData.minOrderQuantity,
        maxOrderQuantity: autoFillData.maxOrderQuantity,
        stockStatus: combinedStock > 0 ? 'in_stock' : 'out_of_stock',
        stockAlert: autoFillData.stockAlert,
        barcode: autoFillData.barcode,
        notes: autoFillData.notes
      };
    });

    setVariants(newVariants);
  };

  // ENHANCED: Update variant with auto-discount calculation
  const updateVariant = (variantId, field, value) => {
    setVariants(prev => prev.map(variant => {
      if (variant.id === variantId) {
        let updatedVariant = { ...variant };

        if (field === 'countInStock') {
          updatedVariant[field] = sanitizeStockValue(value, 0);
        } else if (field === 'price' || field === 'oldPrice') {
          updatedVariant[field] = parseFloat(value) || 0;

          // Auto-calculate discount when price or oldPrice changes
          if (field === 'price' && updatedVariant.oldPrice) {
            updatedVariant.discount = calculateDiscount(value, updatedVariant.oldPrice);
          } else if (field === 'oldPrice' && updatedVariant.price) {
            updatedVariant.discount = calculateDiscount(updatedVariant.price, value);
          }
        } else {
          updatedVariant[field] = value;
        }

        return updatedVariant;
      }
      return variant;
    }));
  };

  const updateVariantNested = (variantId, parentField, childField, value) => {
    setVariants(prev => prev.map(variant =>
      variant.id === variantId
        ? {
          ...variant,
          [parentField]: {
            ...variant[parentField],
            [childField]: value
          }
        }
        : variant
    ));
  };

  const removeVariant = (variantId) => {
    setVariants(prev => prev.filter(variant => variant.id !== variantId));
    if (variantImages[variantId]) {
      const newVariantImages = { ...variantImages };
      delete newVariantImages[variantId];
      setVariantImages(newVariantImages);
    }
  };

  const openVariantDetailDialog = (variant) => {
    setSelectedVariantForDetail(variant);
    setShowVariantDetailDialog(true);
    setDialogTabValue(0);
  };

  const closeVariantDetailDialog = () => {
    setShowVariantDetailDialog(false);
    setSelectedVariantForDetail(null);
    setDialogTabValue(0);
  };

  const openImageUploadDialog = (variant) => {
    setSelectedVariantForImages(variant);
    setShowImageUploadDialog(true);
  };

  const closeImageUploadDialog = () => {
    setShowImageUploadDialog(false);
    setSelectedVariantForImages(null);
  };

  // FIXED: Enhanced variant image upload using dedicated API endpoint
  const onChangeVariantFile = async (e, variantId) => {
    try {
      const files = e.target.files;
      if (!files.length) return;

      setUploadingVariantImages(prev => ({ ...prev, [variantId]: true }));

      const compressionOptions = {
        maxSizeMB: 0.03,
        useWebWorker: true,
        alwaysKeepResolution: true,
        initialQuality: 0.3,
      };

      // Process all files and collect URLs directly
      const newImageUrls = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file || !(
          file.type === "image/jpeg" ||
          file.type === "image/jpg" ||
          file.type === "image/png" ||
          file.type === "image/webp"
        )) {
          context.setAlertBox({
            open: true,
            error: true,
            msg: "Please select valid image files (JPG, PNG, WEBP).",
          });
          continue;
        }

        try {
          // Compress image
          const compressedFile = await imageCompression(file, compressionOptions);

          // Create individual FormData for each image
          const singleImageFormData = new FormData();
          const renamedFile = new File(
            [compressedFile],
            `variant_${variantId}_${i}_${Date.now()}.${file.type.split('/')[1]}`,
            { type: compressedFile.type }
          );
          singleImageFormData.append('images', renamedFile);

          // Upload single image
          const uploadResponse = await uploadImage(`/api/products/upload`, singleImageFormData);

          if (uploadResponse && uploadResponse.success) {
            // Get the uploaded image URL directly from response
            const imageUploadResponse = await fetchDataFromApi(`/api/imageUpload`);

            if (imageUploadResponse && imageUploadResponse.length > 0) {
              const latestUpload = imageUploadResponse[imageUploadResponse.length - 1];
              const uploadedImages = latestUpload?.images || [];

              // Add only new URLs
              uploadedImages.forEach(imgUrl => {
                if (!newImageUrls.includes(imgUrl)) {
                  newImageUrls.push(imgUrl);
                }
              });

              // Clean up immediately after getting URLs
              await deleteData("/api/imageUpload/deleteAllImages");
            }
          }
        } catch (compressionError) {
          console.error('Image processing error:', compressionError);
          context.setAlertBox({
            open: true,
            error: true,
            msg: `Failed to process image ${i + 1}`,
          });
        }
      }

      // Update variant images with new images ONLY ONCE
      if (newImageUrls.length > 0) {
        // Update variantImages state for UI display
        setVariantImages(prev => ({
          ...prev,
          [variantId]: [...(prev[variantId] || []), ...newImageUrls]
        }));

        // Update variants state with new images
        setVariants(prev => prev.map(variant =>
          variant.id === variantId
            ? { ...variant, images: [...(variant.images || []), ...newImageUrls] }
            : variant
        ));

        context.setAlertBox({
          open: true,
          error: false,
          msg: `${newImageUrls.length} variant images uploaded successfully!`,
        });
      }

      // Clear loading state
      setUploadingVariantImages(prev => ({ ...prev, [variantId]: false }));

    } catch (error) {
      console.error('Variant image upload error:', error);
      setUploadingVariantImages(prev => ({ ...prev, [variantId]: false }));

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to upload variant images. Please try again.",
      });
    }
  };

  // FIXED: Enhanced variant image removal using dedicated API endpoint
  const removeVariantImage = async (variantId, imageIndex, imgUrl, imgId) => {
    try {
      console.log('Removing variant image:', imgUrl);

      // Optimistically remove from local state
      setVariantImages(prev => ({
        ...prev,
        [variantId]: prev[variantId]?.filter((_, index) => index !== imageIndex) || []
      }));

      setVariants(prev => prev.map(variant =>
        variant.id === variantId
          ? { ...variant, images: variant.images.filter(img => img !== imgUrl) }
          : variant
      ));

      // Delete from Cloudinary
      const deleteResponse = await deleteImages(`/api/products/deleteImage?img=${encodeURIComponent(imgUrl)}`);
      console.log('Variant image delete response:', deleteResponse);

      context.setAlertBox({
        open: true,
        error: false,
        msg: "Variant image deleted successfully!"
      });
    } catch (error) {
      console.error('Failed to delete variant image:', error);

      // Restore image in case of error
      setVariantImages(prev => ({
        ...prev,
        [variantId]: [...(prev[variantId] || []), imgUrl]
      }));

      setVariants(prev => prev.map(variant =>
        variant.id === variantId
          ? { ...variant, images: [...(variant.images || []), imgUrl] }
          : variant
      ));

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to delete variant image. Please try again."
      });
    }
  };

  const calculateDiscountedPrice = (price, discount) => {
    if (!price || !discount) return price;
    return price - (price * discount / 100);
  };

  const getStockStatusColor = (status) => {
    switch (status) {
      case 'in_stock': return 'success';
      case 'low_stock': return 'warning';
      case 'out_of_stock': return 'error';
      default: return 'default';
    }
  };

  const handleTabChange = (event, newValue) => {
    setDialogTabValue(newValue);
  };

 const handleChangeCategory = (event) => {
  const selectedCatId = event.target.value;

  setcategoryVal(selectedCatId);

  const selectedCategory = context.catData?.categoryList?.find(
    (cat) => cat._id === selectedCatId
  );

  setFormFields((prev) => ({
    ...prev,
    category: selectedCatId,
    catId: selectedCatId,
    catName: selectedCategory?.name || "",
  }));

  // ✅ FILTER SUBCATEGORIES
  if (selectedCategory?.children) {
    setSubCatData(selectedCategory.children);
  } else {
    setSubCatData([]);
  }

  setSubCatVal("");
};

  const handleChangeSubCategory = (event) => {
    setSubCatVal(event.target.value);
    formFields.subCatId = event.target.value;
  };

  const checkSubCatName = (subCatName) => {
    formFields.subCatName = subCatName;
  };

  const handleChangeisFeaturedValue = (event) => {
    setisFeaturedValue(event.target.value);
    setFormFields(() => ({
      ...formFields,
      isFeatured: event.target.value,
    }));
  };

  const handleChangeProductRams = (event) => {
    const {
      target: { value },
    } = event;
    setProductRAMS(
      typeof value === "string" ? value.split(",") : value
    );

    formFields.productRam = value;
  };

  const handleChangeProductWeight = (event) => {
    const {
      target: { value },
    } = event;
    setProductWeight(
      typeof value === "string" ? value.split(",") : value
    );

    formFields.productWeight = value;
  };

  const handleChangeProductSize = (event) => {
    const {
      target: { value },
    } = event;
    setProductSize(
      typeof value === "string" ? value.split(",") : value
    );

    formFields.size = value;
  };

  // ENHANCED: Input change with auto-discount calculation
  const inputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'countInStock') {
      const sanitizedValue = sanitizeStockValue(value, 0);
      setFormFields(prev => ({
        ...prev,
        [name]: sanitizedValue,
      }));
    } else if (name === 'price' || name === 'oldPrice') {
      setFormFields(prev => {
        const updatedFields = {
          ...prev,
          [name]: value,
        };

        // Auto-calculate discount when price or oldPrice changes
        if (name === 'price' && prev.oldPrice) {
          updatedFields.discount = calculateDiscount(value, prev.oldPrice);
        } else if (name === 'oldPrice' && prev.price) {
          updatedFields.discount = calculateDiscount(prev.price, value);
        }

        return updatedFields;
      });
    } else {
      setFormFields(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const selectCat = (cat, id) => {
    formFields.catName = cat;
    formFields.catId = id;
  };

  let img_arr = [];
  let uniqueArray = [];
  let selectedImages = [];

  // FIXED: Don't delete existing images when uploading new ones
  const onChangeFile = async (e, apiEndPoint) => {
    try {
      const files = e.target.files;
      if (!files?.length) return;

      setUploading(true);

      const formdata = new FormData();
      const img_arr = [];

      const options = {
        maxSizeMB: 0.01,
        useWebWorker: true,
        alwaysKeepResolution: true,
        initialQuality: 0.3,
      };

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (
          file &&
          (file.type === 'image/jpeg' ||
            file.type === 'image/jpg' ||
            file.type === 'image/png' ||
            file.type === 'image/webp')
        ) {
          try {
            const compressedFile = await imageCompression(file, options);

            const renamedFile = new File(
              [compressedFile],
              file.name || `image_${Date.now()}_${i}.${file.type.split('/')[1]}`,
              { type: compressedFile.type }
            );

            formdata.append('images', renamedFile);
          } catch (compressionError) {
            console.error('Compression Error:', compressionError);
            context.setAlertBox({
              open: true,
              error: true,
              msg: 'Image compression failed.',
            });
            setUploading(false);
            return false;
          }
        } else {
          context.setAlertBox({
            open: true,
            error: true,
            msg: 'Please select a valid JPG, PNG, WebP image file.',
          });
          setUploading(false);
          return false;
        }
      }

      // Upload new images
      const res = await uploadImage(apiEndPoint, formdata);

      // Get newly uploaded images
      const response = await fetchDataFromApi('/api/imageUpload');
      if (response && response.length !== 0) {
        response.forEach((item) => {
          item?.images?.forEach((img) => {
            img_arr.push({
              id: item?._id,
              img: img,
            });
          });
        });

        const uniqueNewImages = img_arr.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.img === item.img)
        );

        // FIXED: Add new images to existing previews instead of replacing
        const combinedPreviews = [...previews, ...uniqueNewImages];

        // Remove duplicates based on image URL
        const finalPreviews = combinedPreviews.filter(
          (item, index, self) => {
            const imgUrl = typeof item === 'object' ? item.img : item;
            return index === self.findIndex((t) => {
              const tImgUrl = typeof t === 'object' ? t.img : t;
              return tImgUrl === imgUrl;
            });
          }
        );

        setPreviews(finalPreviews);

        setTimeout(() => {
          setUploading(false);
          context.setAlertBox({
            open: true,
            error: false,
            msg: `${uniqueNewImages.length} new image(s) added! Total: ${finalPreviews.length}`,
          });
        }, 200);
      }
    } catch (error) {
      console.error('Upload Error:', error);
      setUploading(false);
      context.setAlertBox({
        open: true,
        error: true,
        msg: 'Upload failed. Please try again.',
      });
    }
  };


  // FIXED: Admin + SubAdmin image removal with proper role check
  const removeImg = async (indexToRemove, imgUrl) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));

    // Check if user is admin (by email) OR subadmin (by role)
    const isAdmin = userInfo?.email === "rismicmartpvtltd@gmail.com";
    const isSubAdmin = userInfo?.role === "subadmin" || userInfo?.role === "sub-admin" || userInfo?.isAdmin === true;

    if (!isAdmin && !isSubAdmin) {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Only Admin or Sub-Admin can delete Product images",
      });
      return;
    }

    // Show confirmation dialog
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this image?\n\nThis action cannot be undone.`
    );

    if (!confirmDelete) {
      return;
    }

    setIsImageRemove(true);

    try {
      console.log('Starting manual image deletion:', { indexToRemove, imgUrl });

      // Step 1: Delete from Cloudinary
      const deleteResponse = await deleteImages(`/api/products/deleteImage?img=${encodeURIComponent(imgUrl)}`);
      console.log('Cloudinary delete response:', deleteResponse);

      // Check if Cloudinary deletion was successful
      if (!deleteResponse || (!deleteResponse.success && deleteResponse.result !== 'ok' && deleteResponse.result !== 'not found')) {
        throw new Error('Failed to delete from Cloudinary');
      }

      // Step 2: Update frontend state - Remove specific image
      const newPreviews = previews.filter((img, index) => {
        if (index === indexToRemove) return false;
        const currentImgUrl = typeof img === 'object' ? img.img : img;
        return currentImgUrl !== imgUrl;
      });

      setPreviews(newPreviews);

      // Step 3: Optional cleanup from temporary storage
      try {
        await deleteData(`/api/imageUpload/deleteImageUrl?img=${encodeURIComponent(imgUrl)}`);
      } catch (collectionError) {
        console.warn('Collection cleanup failed (non-critical):', collectionError);
      }

      context.setAlertBox({
        open: true,
        error: false,
        msg: `Image deleted successfully! Remaining: ${newPreviews.length} image(s)`
      });

    } catch (error) {
      console.error('Error deleting main image:', error);
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to delete image. Please try again."
      });
    } finally {
      setIsImageRemove(false);
    }
  };

  useEffect(() => {
    formFields.location = context.selectedCountry;
  }, [context.selectedCountry]);

  const handleChangeLocation = (selectedOptions) => {
    setSelectedLocation(selectedOptions);
    console.log(selectedOptions);
  };

  // FIXED: Clean variant data helper function
  const cleanVariantDataForSaving = (variantOptions, variants) => {
    // Clean variant options - ensure images are arrays of URLs
    const cleanedOptions = variantOptions.map(option => ({
      ...option,
      values: option.values.map(value => ({
        ...value,
        images: value.images ? value.images.map(img => typeof img === 'object' ? img.img : img) : []
      }))
    }));

    // Clean variants - ensure images are arrays of URLs
    const cleanedVariants = variants.map(variant => ({
      ...variant,
      images: variant.images ? variant.images.map(img => typeof img === 'object' ? img.img : img) : []
    }));

    return { cleanedOptions, cleanedVariants };
  };

  // ENHANCED: Edit product with proper image handling AND ALTERNATIVE PRODUCTS
  const edit_Product = async (e) => {
    e.preventDefault();

    try {
      formFields.location = selectedLocation;

      // FIXED: Properly handle all existing images
      const sanitizedImages = previews.map(img =>
        typeof img === 'object' ? img.img : img
      ).filter(Boolean);

      console.log('Images to save:', sanitizedImages.length);

      // Enhanced form fields
      const sanitizedFormFields = {
        ...formFields,
        countInStock: sanitizeStockValue(formFields.countInStock, 0),
        price: parseFloat(formFields.price) || 0,
        oldPrice: parseFloat(formFields.oldPrice) || 0,
        discount: formFields.discount || calculateDiscount(formFields.price, formFields.oldPrice),
        images: sanitizedImages // All current images
      };

      // Handle variants
      if (hasVariants) {
        const { cleanedOptions, cleanedVariants } = cleanVariantDataForSaving(variantOptions, variants);
        sanitizedFormFields.hasVariants = true;
        sanitizedFormFields.variantOptions = cleanedOptions;
        sanitizedFormFields.variants = cleanedVariants;
      } else {
        sanitizedFormFields.hasVariants = false;
        sanitizedFormFields.variantOptions = [];
        sanitizedFormFields.variants = [];
      }

      // ========== ADD ALTERNATIVE PRODUCTS ==========
      sanitizedFormFields.alternativeProducts = alternativeProducts.map((product, index) => ({
        productId: product._id,
        displayOrder: index
      }));
      // ==============================================

      // Validation
      if (sanitizedImages.length === 0) {
        context.setAlertBox({
          open: true,
          msg: "Please add at least one product image",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.name === "") {
        context.setAlertBox({
          open: true,
          msg: "Please add product name",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.description === "") {
        context.setAlertBox({
          open: true,
          msg: "Please add product description",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.brand === "") {
        context.setAlertBox({
          open: true,
          msg: "Please add product brand",
          error: true,
        });
        return false;
      }

      if (!hasVariants && (sanitizedFormFields.price === null || sanitizedFormFields.price <= 0)) {
        context.setAlertBox({
          open: true,
          msg: "Please add valid product price",
          error: true,
        });
        return false;
      }

      if (!hasVariants && (sanitizedFormFields.oldPrice === null || sanitizedFormFields.oldPrice <= 0)) {
        context.setAlertBox({
          open: true,
          msg: "Please add valid product MRP",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.category === "") {
        context.setAlertBox({
          open: true,
          msg: "Please select a category",
          error: true,
        });
        return false;
      }

      if (!hasVariants && sanitizedFormFields.countInStock === null) {
        context.setAlertBox({
          open: true,
          msg: "Please add product count in stock (0 is allowed for out of stock)",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.rating === 0) {
        context.setAlertBox({
          open: true,
          msg: "Please select product rating",
          error: true,
        });
        return false;
      }

      if (sanitizedFormFields.isFeatured === null) {
        context.setAlertBox({
          open: true,
          msg: "Please select if the product is featured or not",
          error: true,
        });
        return false;
      }

      // ENHANCED: Variant validation
      if (hasVariants) {
        if (variants.length === 0) {
          context.setAlertBox({
            open: true,
            msg: "Please add at least one variant",
            error: true,
          });
          return false;
        }

        const activeVariants = variants.filter(v => v.isActive);
        if (activeVariants.length === 0) {
          context.setAlertBox({
            open: true,
            msg: "Please activate at least one variant",
            error: true,
          });
          return false;
        }

        for (let variant of activeVariants) {
          if (!variant.price || variant.price <= 0) {
            context.setAlertBox({
              open: true,
              msg: `Please set valid price for variant: ${variant.combination.map(c => c.value).join(', ')}`,
              error: true,
            });
            return false;
          }

          if (variant.countInStock === null || variant.countInStock === undefined) {
            context.setAlertBox({
              open: true,
              msg: `Please set stock for variant: ${variant.combination.map(c => c.value).join(', ')} (0 is allowed for out of stock)`,
              error: true,
            });
            return false;
          }

          if (!variant.oldPrice || variant.oldPrice <= 0) {
            context.setAlertBox({
              open: true,
              msg: `Please set valid MRP for variant: ${variant.combination.map(c => c.value).join(', ')}`,
              error: true,
            });
            return false;
          }
        }

        for (let option of variantOptions) {
          for (let value of option.values) {
            if (value.value.trim() && (!value.price || parseFloat(value.price) <= 0)) {
              context.setAlertBox({
                open: true,
                msg: `Please set valid price for option value: ${option.name} - ${value.value}`,
                error: true,
              });
              return false;
            }
            if (value.value.trim() && (!value.oldPrice || parseFloat(value.oldPrice) <= 0)) {
              context.setAlertBox({
                open: true,
                msg: `Please set valid MRP for option value: ${option.name} - ${value.value}`,
                error: true,
              });
              return false;
            }
            if (value.value.trim() && (value.stock === null || value.stock === undefined || value.stock === "")) {
              context.setAlertBox({
                open: true,
                msg: `Please set stock for option value: ${option.name} - ${value.value} (0 is allowed for out of stock)`,
                error: true,
              });
              return false;
            }
          }
        }
      }

      console.log('Final form data - Alternative Products:', sanitizedFormFields.alternativeProducts);

      setIsLoading(true);

      // Send update request
      const response = await editData(`/api/products/${id}`, sanitizedFormFields);

      if (response.success !== false) {
        context.setAlertBox({
          open: true,
          msg: `Product updated successfully with ${sanitizedImages.length} images!`,
          error: false,
        });

        // Optional cleanup of temporary uploads
        try {
          await deleteData("/api/imageUpload/deleteAllImages");
        } catch (cleanupError) {
          console.warn('Cleanup warning:', cleanupError);
        }

        history("/products");
      } else {
        throw new Error(response.error || 'Update failed');
      }

    } catch (error) {
      console.error('Error updating product:', error);
      context.setAlertBox({
        open: true,
        msg: error.error || error.message || "Failed to update product. Please try again.",
        error: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const MAX_SPECIFICATIONS = 6;

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4">
          <h5 className="mb-0">Product Edit</h5>
          <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
            <StyledBreadcrumb
              component={Link}
              to="/"
              label="Dashboard"
              icon={<HomeIcon fontSize="small" />}
              sx={{ cursor: 'pointer' }}
            />

            <StyledBreadcrumb
              component="a"
              label="Products"
              href="#"
              deleteIcon={<ExpandMoreIcon />}
            />
            <StyledBreadcrumb
              label="Product Edit"
              deleteIcon={<ExpandMoreIcon />}
            />
          </Breadcrumbs>
        </div>

        <form className="form" onSubmit={edit_Product}>
          <div className="row">
            <div className="col-md-12">
              <div className="card p-4 mt-0">
                <h5 className="mb-4">Basic Information</h5>

                {/* ALL YOUR EXISTING FORM FIELDS HERE - KEEPING EVERYTHING THE SAME */}
                {/* I'm truncating this in the response but you need to keep ALL your existing fields */}

                <div className="form-group">
                  <h6>PRODUCT NAME</h6>
                  <input
                    type="text"
                    name="name"
                    value={formFields.name}
                    onChange={inputChange}
                  />
                </div>


                <div className="form-group">
                  <h6>DESCRIPTION</h6>
                  <textarea
                    rows={5}
                    cols={10}
                    value={formFields.description}
                    name="description"
                    onChange={inputChange}
                  />
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>CATEGORY</h6>

                      {categoryVal !== "" && (
                        <Select
                          value={categoryVal}
                          onChange={handleChangeCategory}
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          className="w-100"
                        >
                          {context.catData?.categoryList?.length !== 0 &&
                            context.catData?.categoryList?.map((cat, index) => {
                              return (
                                <MenuItem
                                  className="text-capitalize"
                                  value={cat._id}
                                  key={index}
                                  onClick={() => selectCat(cat.name, cat._id)}
                                >
                                  {cat.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      )}
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>SUB CATEGORY</h6>
                      <Select
                        value={subCatVal}
                        onChange={handleChangeSubCategory}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        className="w-100"
                      >
                        <MenuItem value="">
                          <em value={null}>None</em>
                        </MenuItem>
                        {subCatData?.length !== 0 &&
                          subCatData?.map((subCat, index) => {
                            return (
                              <MenuItem
                                className="text-capitalize"
                                value={subCat._id}
                                key={index}
                                onClick={() => checkSubCatName(subCat.name)}
                              >
                                {subCat.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>
                        PRICE
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Base price - will be combined with variant prices)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="price"
                        value={formFields.price || ""}
                        onChange={inputChange}
                        min="0"
                        step="0.01"
                        placeholder="Enter price"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>
                        MRP
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Base MRP - will be combined with variant MRPs)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="oldPrice"
                        value={formFields.oldPrice || ""}
                        onChange={inputChange}
                        min="0"
                        step="0.01"
                        placeholder="Enter MRP"
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>
                        PRODUCT STOCK
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Individual variant stock will be used)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="countInStock"
                        value={formFields.countInStock === null ? "" : formFields.countInStock}
                        onChange={inputChange}
                        min="0"
                        step="1"
                        placeholder="Enter stock (0 for out of stock)"
                      />

                      {formFields.countInStock !== null && (
                        <Box mt={1}>
                          <Typography
                            variant="caption"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 0.5,
                              padding: '4px 8px',
                              borderRadius: 1,
                              color: getStockStatusDisplay(formFields.countInStock).color,
                              backgroundColor: getStockStatusDisplay(formFields.countInStock).bgColor,
                              border: `1px solid ${getStockStatusDisplay(formFields.countInStock).borderColor}`
                            }}
                          >
                            {getStockStatusDisplay(formFields.countInStock).icon}
                            {getStockStatusDisplay(formFields.countInStock).text}
                          </Typography>
                        </Box>
                      )}
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6 className="text-uppercase">See in Front</h6>
                      <Select
                        value={isFeaturedValue}
                        onChange={handleChangeisFeaturedValue}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        className="w-100"
                      >
                        <MenuItem value="">
                          <em value={null}>None</em>
                        </MenuItem>
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>BRAND</h6>
                      <input
                        type="text"
                        name="brand"
                        value={formFields.brand}
                        onChange={inputChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>
                        DISCOUNT (%)
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Auto-calculated from price difference)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="discount"
                        value={formFields.discount || ""}
                        onChange={inputChange}
                        min="0"
                        max="100"
                        step="0.01"
                        placeholder="Auto-calculated"
                        readOnly
                      />
                      {formFields.discount > 0 && (
                        <Typography variant="caption" color="success.main" display="block">
                          You save: ₹{((parseFloat(formFields.oldPrice) - parseFloat(formFields.price)) || 0).toFixed(2)}
                        </Typography>
                      )}
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>PRODUCT RAMS</h6>
                      <Select
                        multiple
                        value={productRams}
                        onChange={handleChangeProductRams}
                        displayEmpty
                        className="w-100"
                        MenuProps={MenuProps}
                      >
                        {productRAMSData?.map((item, index) => {
                          return (
                            <MenuItem value={item.productRam} key={index}>
                              {item.productRam}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>PRODUCT WEIGHT</h6>
                      <Select
                        multiple
                        value={productWeight}
                        onChange={handleChangeProductWeight}
                        displayEmpty
                        MenuProps={MenuProps}
                        className="w-100"
                      >
                        {productWEIGHTData?.map((item, index) => {
                          return (
                            <MenuItem value={item.productWeight} key={index}>
                              {item.productWeight}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>PRODUCT SIZE</h6>
                      <Select
                        multiple
                        value={productSize}
                        onChange={handleChangeProductSize}
                        displayEmpty
                        MenuProps={MenuProps}
                        className="w-100"
                      >
                        {productSIZEData?.map((item, index) => {
                          return (
                            <MenuItem value={item.size} key={index}>{item.size}</MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <h6>RATINGS</h6>
                      <Rating
                        name="simple-controlled"
                        value={ratingsValue}
                        onChange={(event, newValue) => {
                          setRatingValue(newValue);
                          setFormFields(() => ({
                            ...formFields,
                            rating: newValue,
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* ... ALL YOUR OTHER EXISTING FORM FIELDS ... */}

                {/* ========== ALTERNATIVE PRODUCTS SECTION (ADD THIS BEFORE VARIANTS) ========== */}
                <div className="row mt-4">
                  <div className="col-12">
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="alternative-products-content"
                        id="alternative-products-header"
                      >
                        <Typography variant="h6">
                          <Box display="flex" alignItems="center" gap={1}>
                            <AiOutlineUnorderedList />
                            Alternative Products ({alternativeProducts.length})
                          </Box>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Alert severity="info" sx={{ mb: 2 }}>
                          Add alternative or similar products that customers might be interested in if this product is unavailable.
                        </Alert>

                        {/* Display Selected Alternative Products */}
                        {alternativeProducts.length > 0 && (
                          <Box mb={3}>
                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                              Selected Alternatives
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1}>
                              {alternativeProducts.map((product) => (
                                <MuiChip
                                  key={product._id}
                                  label={product.name}
                                  onDelete={() => handleRemoveAlternative(product._id)}
                                  avatar={<Avatar src={product.images?.[0]} alt={product.name} />}
                                  color="primary"
                                  variant="outlined"
                                />
                              ))}
                            </Stack>
                          </Box>
                        )}

                        {/* Add Alternative Button */}
                        <Button
                          variant="contained"
                          startIcon={<MdAdd />}
                          onClick={handleOpenAlternativeDialog}
                          fullWidth
                          size="large"
                          sx={{ mt: 2 }}
                        >
                          Add Alternative Products
                        </Button>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
                {/* ======================================================= */}

                {/* ALL YOUR EXISTING VARIANT SECTIONS STAY THE SAME */}
                {/* ALL YOUR EXISTING SPECIFICATION AND ADDITIONAL INFO SECTIONS STAY THE SAME */}
                {/* I'm keeping all of this - just showing key sections */}

                {/* Enhanced Variant Toggle */}
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="form-group">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={hasVariants}
                            onChange={handleVariantToggle}
                            color="primary"
                          />
                        }
                        label={
                          <Box display="flex" alignItems="center" gap={1}>
                            <FiPackage />
                            <Typography variant="h6">Enable Product Variants</Typography>
                          </Box>
                        }
                      />
                      <Typography variant="caption" color="textSecondary" display="block">
                        Create multiple variations with individual pricing, stock, and images for each option
                      </Typography>
                    </div>
                  </div>
                </div>

                {/* ENHANCED: Variant Options Section with auto-fill and auto-discount */}
                {hasVariants && (
                  <div className="row mt-4">
                    <div className="col-12">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="variant-options-content"
                          id="variant-options-header"
                        >
                          <Typography variant="h6">
                            <Box display="flex" alignItems="center" gap={1}>
                              <MdEdit />
                              Variant Options with Auto-Fill & Auto-Discount
                            </Box>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Alert severity="info" sx={{ mb: 3 }}>
                            Set individual prices, stock, and images for each option value. Discounts are auto-calculated from price differences. SKUs are auto-generated. Stock value of 0 means out of stock.
                          </Alert>

                          <Box>
                            {variantOptions.map((option, optionIndex) => (
                              <Card key={optionIndex} sx={{ mb: 3, border: '2px solid #e0e0e0', borderRadius: 2 }}>
                                <CardHeader
                                  title={
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                      <Typography variant="h6" color="primary">
                                        <FiPackage style={{ marginRight: 8 }} />
                                        Variant {optionIndex + 1}
                                      </Typography>
                                      {variantOptions.length > 1 && (
                                        <IconButton
                                          color="error"
                                          onClick={() => removeVariantOption(optionIndex)}
                                          sx={{ ml: 2 }}
                                        >
                                          <MdDelete />
                                        </IconButton>
                                      )}
                                    </Box>
                                  }
                                  sx={{ pb: 1, backgroundColor: '#f8f9fa' }}
                                />
                                <CardContent>
                                  <Box mb={3}>
                                    <Typography variant="body1" fontWeight="bold" gutterBottom color="text.primary">
                                      Variant Name
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      placeholder="e.g., Color, Size, Material"
                                      value={option.name}
                                      onChange={(e) => updateVariantOptionName(optionIndex, e.target.value)}
                                      variant="outlined"
                                      size="medium"
                                      sx={{
                                        '& .MuiOutlinedInput-root': {
                                          '&:hover fieldset': {
                                            borderColor: '#1976d2',
                                          },
                                        },
                                      }}
                                    />
                                  </Box>

                                  <Typography variant="body1" fontWeight="bold" gutterBottom color="text.primary">
                                    Variant Values & Settings
                                  </Typography>

                                  {option.values.map((valueObj, valueIndex) => (
                                    <Card key={valueIndex} sx={{ mb: 3, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#fafafa' }}>
                                      <CardHeader
                                        title={
                                          <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography variant="subtitle1" color="secondary">
                                              <BiMoney style={{ marginRight: 8 }} />
                                              Value {valueIndex + 1}
                                            </Typography>
                                            {option.values.length > 1 && (
                                              <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() => removeVariantOptionValue(optionIndex, valueIndex)}
                                              >
                                                <IoCloseSharp />
                                              </IconButton>
                                            )}
                                          </Box>
                                        }
                                        sx={{ pb: 1, backgroundColor: '#ffffff' }}
                                      />
                                      <CardContent>
                                        <Grid container spacing={3}>
                                          {/* Value Name */}
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              fullWidth
                                              label="Variant Name "
                                              placeholder="e.g., Red, Large, Cotton"
                                              value={valueObj.value}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'value', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                            />
                                          </Grid>

                                          {/* Auto-generated SKU */}
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              fullWidth
                                              label="SKU (Auto-generated)"
                                              value={valueObj.sku}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'sku', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              helperText="Auto-filled when value name is entered"
                                            />
                                          </Grid>

                                          {/* Pricing Section */}
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Current Price "
                                              type="number"
                                              value={valueObj.price}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'price', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                              }}
                                              placeholder="Enter price"
                                              inputProps={{ min: 0, step: 0.01 }}
                                            />
                                          </Grid>

                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="MRP (Old Price) "
                                              type="number"
                                              value={valueObj.oldPrice}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'oldPrice', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                              }}
                                              placeholder="Enter MRP"
                                              inputProps={{ min: 0, step: 0.01 }}
                                            />
                                          </Grid>

                                          {/* Auto-calculated Discount Display */}
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Discount % (Auto-calculated)"
                                              type="number"
                                              value={valueObj.discount || calculateDiscount(valueObj.price, valueObj.oldPrice) || ""}
                                              variant="outlined"
                                              size="small"
                                              InputProps={{
                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                readOnly: true,
                                              }}
                                              sx={{
                                                '& .MuiInputBase-input': {
                                                  color: '#2e7d32',
                                                  fontWeight: 'bold'
                                                }
                                              }}
                                            />
                                          </Grid>

                                          {/* Stock field with 0 support and visual indicators */}
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              fullWidth
                                              label="Stock Quantity "
                                              type="number"
                                              value={valueObj.stock}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'stock', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                endAdornment: <InputAdornment position="end">units</InputAdornment>,
                                              }}
                                              placeholder="0 for out of stock"
                                              inputProps={{ min: 0, step: 1 }}
                                            />

                                            {/* Stock status indicator */}
                                            {valueObj.stock !== "" && (
                                              <Box mt={1}>
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                    padding: '2px 6px',
                                                    borderRadius: 1,
                                                    fontSize: '0.75rem',
                                                    color: getStockStatusDisplay(valueObj.stock).color,
                                                    backgroundColor: getStockStatusDisplay(valueObj.stock).bgColor,
                                                    border: `1px solid ${getStockStatusDisplay(valueObj.stock).borderColor}`
                                                  }}
                                                >
                                                  {getStockStatusDisplay(valueObj.stock).icon}
                                                  {getStockStatusDisplay(valueObj.stock).text}
                                                </Typography>
                                              </Box>
                                            )}
                                          </Grid>

                                          {/* Status and Price Summary */}
                                          <Grid item xs={12} md={6}>
                                            <Box display="flex" alignItems="center" gap={2} sx={{ height: '100%' }}>
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={valueObj.isActive}
                                                    onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'isActive', e.target.checked)}
                                                    color="primary"
                                                    size="small"
                                                  />
                                                }
                                                label="Active"
                                              />

                                              {/* Price Summary */}
                                              {valueObj.price && valueObj.oldPrice && parseFloat(valueObj.price) > 0 && parseFloat(valueObj.oldPrice) > parseFloat(valueObj.price) && (
                                                <Box>
                                                  <Typography variant="caption" color="success.main" fontWeight="bold">
                                                    Save: ₹{(parseFloat(valueObj.oldPrice) - parseFloat(valueObj.price)).toFixed(2)}
                                                  </Typography>
                                                </Box>
                                              )}
                                            </Box>
                                          </Grid>

                                          {/* Images Section */}
                                          <Grid item xs={12}>
                                            <Box>
                                              <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                                <Box display="flex" alignItems="center" gap={1}>
                                                  <MdImage />
                                                  Variant Value Images
                                                  <Badge badgeContent={valueObj.images?.length || 0} color="primary">
                                                    <FiCamera />
                                                  </Badge>
                                                </Box>
                                              </Typography>

                                              <Grid container spacing={1} sx={{ mt: 1 }}>
                                                {valueObj.images?.map((img, imgIndex) => (
                                                  <Grid item xs={3} sm={2} md={1} key={imgIndex}>
                                                    <Box position="relative">
                                                      <LazyLoadImage
                                                        alt={`${valueObj.value}-${imgIndex}`}
                                                        effect="blur"
                                                        src={typeof img === 'object' ? img.img : img}
                                                        style={{
                                                          width: '100%',
                                                          height: 70,
                                                          objectFit: 'cover',
                                                          borderRadius: 8,
                                                          border: '2px solid #ddd',
                                                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                        }}
                                                      />
                                                      <IconButton
                                                        size="small"
                                                        color="error"
                                                        sx={{
                                                          position: 'absolute',
                                                          top: -8,
                                                          right: -8,
                                                          background: 'white',
                                                          width: 24,
                                                          height: 24,
                                                          '&:hover': { background: '#ffebee' },
                                                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                        }}
                                                        onClick={() => removeOptionValueImage(optionIndex, valueIndex, imgIndex, typeof img === 'object' ? img.img : img, typeof img === 'object' ? img.id : null)}
                                                      >
                                                        <IoCloseSharp style={{ fontSize: 14 }} />
                                                      </IconButton>
                                                    </Box>
                                                  </Grid>
                                                ))}

                                                <Grid item xs={3} sm={2} md={1}>
                                                  <Box
                                                    sx={{
                                                      height: 70,
                                                      border: '2px dashed #ccc',
                                                      borderRadius: 2,
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      cursor: 'pointer',
                                                      backgroundColor: '#f9f9f9',
                                                      '&:hover': {
                                                        borderColor: '#1976d2',
                                                        backgroundColor: '#e3f2fd'
                                                      },
                                                      transition: 'all 0.3s ease'
                                                    }}
                                                    component="label"
                                                  >
                                                    {uploadingOptionImages[`${optionIndex}-${valueIndex}`] ? (
                                                      <CircularProgress size={20} />
                                                    ) : (
                                                      <BiImageAdd size={28} color="#1976d2" />
                                                    )}
                                                    <input
                                                      type="file"
                                                      multiple
                                                      hidden
                                                      accept="image/*"
                                                      onChange={(e) => onChangeOptionValueFile(e, optionIndex, valueIndex)}
                                                    />
                                                  </Box>
                                                </Grid>
                                              </Grid>

                                              <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                                                Upload images specific to this variant value (JPG, PNG, WebP)
                                              </Typography>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </CardContent>
                                    </Card>
                                  ))}

                                  <Button
                                    variant="outlined"
                                    startIcon={<MdAdd />}
                                    onClick={() => addVariantOptionValue(optionIndex)}
                                    sx={{
                                      mt: 2,
                                      borderStyle: 'dashed',
                                      '&:hover': {
                                        borderStyle: 'solid',
                                        backgroundColor: 'primary.light'
                                      }
                                    }}
                                    fullWidth
                                  >
                                    Add Another Variant Value
                                  </Button>
                                </CardContent>
                              </Card>
                            ))}

                            <Button
                              variant="contained"
                              startIcon={<MdAdd />}
                              onClick={addVariantOption}
                              size="large"
                              sx={{
                                mt: 2,
                                py: 1.5,
                                fontSize: '1.1rem',
                                boxShadow: '0 4px 8px rgba(25, 118, 210, 0.3)',
                                '&:hover': {
                                  boxShadow: '0 6px 12px rgba(25, 118, 210, 0.4)',
                                }
                              }}
                              fullWidth
                            >
                              Add New Variant Option
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                )}

                {/* Generated Variants Display with auto-calculated values and separate images */}
                {hasVariants && variants.length > 0 && (
                  <div className="row mt-4">
                    <div className="col-12">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="generated-variants-content"
                          id="generated-variants-header"
                        >
                          <Typography variant="h6">
                            <Box display="flex" alignItems="center" gap={1}>
                              <MdInventory />
                              Generated Variants ({variants.length}) - Auto-filled & Calculated
                            </Box>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Alert severity="success" sx={{ mb: 3 }}>
                            These variants are automatically generated from your option combinations. Prices, stock, and discounts are auto-calculated. SKUs are auto-generated. Stock value of 0 means out of stock. Variant-specific images are separate from option value images.
                          </Alert>

                          <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2 }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                  <TableCell><strong>Active</strong></TableCell>
                                  <TableCell><strong>Variant Combination</strong></TableCell>
                                  <TableCell><strong>Combined Price</strong></TableCell>
                                  <TableCell><strong>Combined MRP</strong></TableCell>
                                  <TableCell><strong>Auto Discount</strong></TableCell>
                                  <TableCell><strong>Total Stock</strong></TableCell>
                                  <TableCell><strong>Auto SKU</strong></TableCell>
                                  <TableCell><strong>Variant Images</strong></TableCell>
                                  <TableCell><strong>Actions</strong></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {variants.map((variant) => {
                                  const stockDisplay = getStockStatusDisplay(variant.countInStock);
                                  return (
                                    <TableRow key={variant.id} hover sx={{ '&:hover': { backgroundColor: '#f8f9fa' } }}>
                                      <TableCell>
                                        <Switch
                                          checked={variant.isActive}
                                          onChange={(e) => updateVariant(variant.id, 'isActive', e.target.checked)}
                                          size="small"
                                          color="primary"
                                        />
                                      </TableCell>

                                      <TableCell>
                                        <Box>
                                          <Typography variant="body2" fontWeight="bold">
                                            {variant.combination.map(c => c.value).join(' + ')}
                                          </Typography>
                                          <Typography variant="caption" color="textSecondary">
                                            {variant.combination.map(c => `${c.option}: ${c.value}`).join(' | ')}
                                          </Typography>
                                        </Box>
                                      </TableCell>

                                      <TableCell>
                                        <Typography variant="body2" color="primary" fontWeight="bold">
                                          ₹{variant.price?.toFixed(2)}
                                        </Typography>
                                      </TableCell>

                                      <TableCell>
                                        <Typography variant="body2" color="textSecondary">
                                          ₹{variant.oldPrice?.toFixed(2)}
                                        </Typography>
                                      </TableCell>

                                      <TableCell>
                                        <MuiChip
                                          label={`${variant.discount?.toFixed(1) || 0}%`}
                                          size="small"
                                          color={variant.discount > 0 ? "success" : "default"}
                                        />
                                        {variant.discount > 0 && (
                                          <Typography variant="caption" color="success.main" display="block">
                                            Save: ₹{(variant.oldPrice - variant.price).toFixed(2)}
                                          </Typography>
                                        )}
                                      </TableCell>

                                      <TableCell>
                                        <MuiChip
                                          label={stockDisplay.text}
                                          icon={stockDisplay.icon}
                                          size="small"
                                          sx={{
                                            color: stockDisplay.color,
                                            backgroundColor: stockDisplay.bgColor,
                                            border: `1px solid ${stockDisplay.borderColor}`,
                                            '& .MuiChip-icon': { color: stockDisplay.color }
                                          }}
                                        />
                                      </TableCell>

                                      <TableCell>
                                        <Typography variant="caption" sx={{
                                          fontFamily: 'monospace',
                                          backgroundColor: '#f5f5f5',
                                          padding: '2px 4px',
                                          borderRadius: 1,
                                          display: 'block'
                                        }}>
                                          {variant.sku}
                                        </Typography>
                                      </TableCell>

                                      <TableCell>
                                        <Box display="flex" alignItems="center" gap={1}>
                                          <Box display="flex" flexWrap="wrap" gap={0.5}>
                                            {variant.images?.slice(0, 2).map((img, imgIndex) => (
                                              <LazyLoadImage
                                                key={imgIndex}
                                                alt={`variant-${variant.id}-${imgIndex}`}
                                                effect="blur"
                                                src={img} // img is now a string URL
                                                style={{
                                                  width: 30,
                                                  height: 30,
                                                  objectFit: 'cover',
                                                  borderRadius: 4,
                                                  border: '1px solid #ddd'
                                                }}
                                              />
                                            ))}
                                            {variant.images?.length > 2 && (
                                              <Box
                                                sx={{
                                                  width: 30,
                                                  height: 30,
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  backgroundColor: '#f0f0f0',
                                                  borderRadius: 1,
                                                  fontSize: '8px',
                                                  border: '1px solid #ddd'
                                                }}
                                              >
                                                +{variant.images.length - 2}
                                              </Box>
                                            )}
                                          </Box>
                                          <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => openImageUploadDialog(variant)}
                                            sx={{ ml: 1 }}
                                          >
                                            <FiCamera />
                                          </IconButton>
                                        </Box>
                                      </TableCell>

                                      <TableCell>
                                        <Box display="flex" gap={1}>
                                          <Tooltip title="Edit Details">
                                            <IconButton
                                              color="primary"
                                              size="small"
                                              onClick={() => openVariantDetailDialog(variant)}
                                            >
                                              <FiEdit3 />
                                            </IconButton>
                                          </Tooltip>
                                          <Tooltip title="Remove Variant">
                                            <IconButton
                                              color="error"
                                              size="small"
                                              onClick={() => removeVariant(variant.id)}
                                            >
                                              <MdDelete />
                                            </IconButton>
                                          </Tooltip>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                )}

                {/* FIXED: Variant-specific Image Upload Dialog */}
                <Dialog
                  open={showImageUploadDialog}
                  onClose={closeImageUploadDialog}
                  maxWidth="md"
                  fullWidth
                >
                  <DialogTitle>
                    <Box display="flex" alignItems="center" gap={1}>
                      <FiCamera />
                      Upload Variant-Specific Images
                      {selectedVariantForImages && (
                        <MuiChip
                          label={selectedVariantForImages.combination.map(c => c.value).join(' / ')}
                          color="primary"
                          variant="outlined"
                        />
                      )}
                    </Box>
                  </DialogTitle>
                  <DialogContent>
                    {selectedVariantForImages && (
                      <Box sx={{ mt: 2 }}>
                        <Alert severity="info" sx={{ mb: 3 }}>
                          Upload images specific to this variant combination. These are separate from option value images and main product images.
                        </Alert>

                        <Grid container spacing={2}>
                          {variantImages[selectedVariantForImages.id]?.map((img, imgIndex) => (
                            <Grid item xs={6} sm={4} md={3} key={imgIndex}>
                              <Box position="relative">
                                <LazyLoadImage
                                  alt={`variant-${selectedVariantForImages.id}-${imgIndex}`}
                                  effect="blur"
                                  src={typeof img === 'object' ? img.img : img}
                                  style={{
                                    width: '100%',
                                    height: 150,
                                    objectFit: 'cover',
                                    borderRadius: 8,
                                    border: '1px solid #e0e0e0'
                                  }}
                                />
                                <IconButton
                                  size="small"
                                  color="error"
                                  sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    background: 'rgba(255,255,255,0.9)',
                                    '&:hover': { background: 'rgba(255,255,255,1)' }
                                  }}
                                  onClick={() => removeVariantImage(selectedVariantForImages.id, imgIndex, typeof img === 'object' ? img.img : img, typeof img === 'object' ? img.id : null)}
                                >
                                  <IoCloseSharp />
                                </IconButton>
                              </Box>
                            </Grid>
                          ))}

                          <Grid item xs={6} sm={4} md={3}>
                            <Box
                              sx={{
                                height: 150,
                                border: '2px dashed #ccc',
                                borderRadius: 2,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                '&:hover': { borderColor: '#1976d2' }
                              }}
                              component="label"
                            >
                              {uploadingVariantImages[selectedVariantForImages.id] ? (
                                <CircularProgress />
                              ) : (
                                <>
                                  <BiImageAdd size={40} color="#999" />
                                  <Typography variant="caption" color="textSecondary" textAlign="center">
                                    Add Variant Images
                                  </Typography>
                                </>
                              )}
                              <input
                                type="file"
                                multiple
                                hidden
                                accept="image/*"
                                onChange={(e) => onChangeVariantFile(e, selectedVariantForImages.id)}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={closeImageUploadDialog}>Close</Button>
                  </DialogActions>
                </Dialog>

                {/*add specification  */}
                <div className="row mt-4">
                  <div className="col">

                    <h6 className="edit-section-title mb-3">ADD SPECIFICATION</h6>
                    {formFields.specification.map((item, index) => (
                      <div className="row mb-2 align-items-center" key={index}>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control edit-info-input"
                            placeholder="Custom Key..."
                            value={item.key}
                            onChange={(e) => handlespecificationChange(index, "key", e.target.value)}
                          />
                        </div>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control edit-info-input"
                            placeholder="Custom Value..."
                            value={item.value}
                            onChange={(e) => handlespecificationChange(index, "value", e.target.value)}
                          />
                        </div>
                        <div className="col-auto">
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            className="edit-remove-btn"
                            onClick={() => removespecification(index)}
                          >
                            <IoCloseSharp />
                          </Button>
                        </div>
                      </div>
                    ))}

                    {formFields.specification.length < MAX_SPECIFICATIONS ? (
                      <Button
                        variant="contained"
                        className="edit-add-more-btn mt-2"
                        onClick={() =>
                          setFormFields({
                            ...formFields,
                            specification: [...formFields.specification, { key: "", value: "" }],
                          })
                        }
                      >
                        Add specification
                      </Button>
                    ) : (
                      <p className="text-muted mt-2">Maximum of 6 specifications allowed.</p>
                    )}
                  </div>
                </div>
                {/* add specification */}

                {/* additional info */}
                <div className="row mt-4">
                  <div className="col">
                    <h6 className="edit-section-title mb-3">ADDITIONAL INFO</h6>
                    {formFields.additionalInfo.map((item, index) => (
                      <div className="row mb-2 align-items-center" key={index}>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control edit-info-input"
                            placeholder="Custom Key..."
                            value={item.key}
                            onChange={(e) => handleAdditionalInfoChange(index, "key", e.target.value)}
                          />
                        </div>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control edit-info-input"
                            placeholder="Custom Value..."
                            value={item.value}
                            onChange={(e) => handleAdditionalInfoChange(index, "value", e.target.value)}
                          />
                        </div>
                        <div className="col-auto">
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            className="edit-remove-btn"
                            onClick={() => removeAdditionalInfo(index)}
                          >
                            <IoCloseSharp />
                          </Button>
                        </div>
                      </div>
                    ))}
                    <Button
                      variant="contained"
                      className="edit-add-more-btn mt-2"
                      onClick={() =>
                        setFormFields({
                          ...formFields,
                          additionalInfo: [...formFields.additionalInfo, { key: "", value: "" }],
                        })
                      }
                    >
                      Add More Info
                    </Button>
                  </div>
                </div>
                {/* additional info */}

                <div className="row">
                  {selectedLocation?.length !== 0 && (
                    <div className="col-md-12">
                      <div className="form-group">
                        <h6>LOCATION</h6>

                        <Select2
                          defaultValue={selectedLocation}
                          isMulti
                          name="location"
                          options={countryList}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={handleChangeLocation}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Enhanced Image Upload Section with Manual Controls */}
          <div className="card p-4 mt-0">
            <div className="imagesUploadSec">
              <h5 className="mb-4 d-flex align-items-center justify-content-between">
                Media And Published
                <span className="badge bg-primary">{previews?.length || 0} Images</span>
              </h5>

              {/* Image Preview with Manual Delete */}
              <div className="imgUploadBox d-flex align-items-center">
                {previews && previews.length > 0 &&
                  previews.map((img, index) => {
                    const imageUrl = typeof img === 'object' ? img.img : img;
                    return (
                      <div className="uploadBox" key={index}>
                        <span
                          className="remove"
                          onClick={() => removeImg(index, imageUrl)}
                          style={{
                            cursor: isImageRemove ? 'not-allowed' : 'pointer',


                            opacity: isImageRemove ? 0.5 : 1,
                            backgroundColor: '#dc3545',
                            color: 'white',


                          }}
                        >
                          <IoCloseSharp />
                        </span>
                        <div className="box">
                          <LazyLoadImage
                            alt={`product-image-${index}`}
                            effect="blur"
                            className="w-100"
                            src={imageUrl}
                          />
                        </div>
                      </div>
                    );
                  })}

                <div className="uploadBox">
                  {uploading ? (
                    <div className="progressBar text-center d-flex align-items-center justify-content-center flex-column">
                      <CircularProgress />
                      <span>Uploading...</span>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        multiple
                        onChange={(e) => onChangeFile(e, "/api/products/upload")}
                        name="images"
                        accept="image/jpeg,image/jpg,image/png,image/webp"
                      />
                      <div className="info">
                        <FaRegImages />
                        <h5>Image upload</h5>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <br />

               <div className="floating-btn-wrapper">
                <Button type="submit" className="btn-blue btn-lg btn-big">
                  <FaCloudUploadAlt /> &nbsp;
                  {isLoading ? (
                    <CircularProgress color="inherit" className="loader" />
                  ) : (
                    "UPDATE AND VIEW"
                  )}
                </Button>
              </div>
            </div>
          </div>












          {/* ALL YOUR EXISTING IMAGE UPLOAD SECTION STAYS THE SAME */}
          {/* ALL YOUR EXISTING SUBMIT BUTTON STAYS THE SAME */}

        </form>
      </div>

      {/* ========== ALTERNATIVE PRODUCTS DIALOG (ADD THIS AT THE END BEFORE CLOSING) ========== */}
      <Dialog
        open={openAlternativeDialog}
        onClose={handleCloseAlternativeDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">
              <AiOutlineUnorderedList style={{ marginRight: 8 }} />
              Select Alternative Products
            </Typography>
            <IconButton onClick={handleCloseAlternativeDialog}>
              <IoCloseSharp />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Search Box */}
          <TextField
            fullWidth
            placeholder="Search by product name or brand..."
            value={searchAlternative}
            onChange={(e) => setSearchAlternative(e.target.value)}
            sx={{ mb: 2 }}
            variant="outlined"
            size="small"
          />

          {/* Loading State */}
          {loadingAlternatives && (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          )}

          {/* Available Products List */}
          {!loadingAlternatives && (
            <List sx={{ maxHeight: 400, overflow: 'auto' }}>
              {filteredAvailableProducts.length === 0 ? (
                <Alert severity="info">No products available</Alert>
              ) : (
                filteredAvailableProducts.map((product) => (
                  <ListItem
                    key={product._id}
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      mb: 1,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: '#f5f5f5'
                      }
                    }}
                    onClick={() => handleAddAlternative(product)}
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={product.images?.[0]}
                        alt={product.name}
                        variant="rounded"
                        sx={{ width: 60, height: 60 }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="body1" fontWeight="bold">
                          {product.name}
                        </Typography>
                      }
                      secondary={
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Brand: {product.brand}
                          </Typography>
                          <br />
                          <Typography variant="caption" color="primary" fontWeight="bold">
                            ₹{product.price} {product.oldPrice && `(MRP: ₹${product.oldPrice})`}
                          </Typography>
                        </Box>
                      }
                    />
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        checked={alternativeProducts.some(p => p._id === product._id)}
                        onChange={() => handleAddAlternative(product)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              )}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlternativeDialog} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================== */}
    </>
  );
};

export default EditUpload;
